import { type Trello } from "../types/trello"

// Date and duration on one row, the note on its own below it, then the buttons
// (see card-back-section/LogTimeForm).
const LOG_TIME_POPUP_HEIGHT = 290

/**
 * Opens the log-time screen, for a new entry or an existing one.
 *
 * The card button is the only way to log the *first* entry on a card: the card
 * back section stays away until a card has time on it, so an affordance that
 * lived only there could never be used to create one. Editing comes here too,
 * so there is one form rather than two that can drift apart.
 *
 * Pass `mouseEvent` to anchor the popup to the click.
 */
export const openLogTimePopup = (
  t: Trello.PowerUp.IFrame,
  mouseEvent?: MouseEvent,
  entryId?: number
) =>
  t.popup({
    title: entryId ? "Edit time" : "Log time",
    url: t.signUrl("./log-time.html"),
    // Read back inside the iframe with `t.arg("entryId")`.
    args: entryId ? { entryId } : undefined,
    height: LOG_TIME_POPUP_HEIGHT,
    mouseEvent,
  })
